/** Labels for supplier invoice HTML print (FR / AR). */

export const invoicePrintFr = {
  article: 'Article',
  consolidatedTitle: 'Factures incluses',
  colInvoiceNumber: 'N° Facture',
  colDate: 'Date',
  colTotal: 'Total',
  colRemaining: 'Restant',
  typeConsolidated: 'Consolidée',
  typeOrder: 'Commande',
  typePurchase: 'Achat',
  typeNormal: 'Normale',
  supplierName: 'Nom',
  supplierAddress: 'Adresse',
  supplierPhone: 'Téléphone',
  docTitle: 'FACTURE',
  invoiceNumber: 'N° Facture',
  date: 'Date',
  type: 'Type',
  supplierInfo: 'Informations Fournisseur',
  colProduct: 'Produit',
  colSku: 'SKU',
  colQty: 'Qté',
  colUnitPrice: 'PU',
  total: 'Total',
  paid: 'Payé',
  remaining: 'Restant',
  reportGenerated: 'Généré le',
  reportPhone: 'Tél',
  reportEmail: 'Email',
};

export const invoicePrintAr = {
  article: 'عنصر',
  consolidatedTitle: 'الفواتير المدمجة',
  colInvoiceNumber: 'رقم الفاتورة',
  colDate: 'التاريخ',
  colTotal: 'الإجمالي',
  colRemaining: 'المتبقي',
  typeConsolidated: 'موحدة',
  typeOrder: 'طلبات',
  typePurchase: 'مشتريات',
  typeNormal: 'عادية',
  supplierName: 'الاسم',
  supplierAddress: 'العنوان',
  supplierPhone: 'الهاتف',
  docTitle: 'فاتورة',
  invoiceNumber: 'رقم الفاتورة',
  date: 'التاريخ',
  type: 'النوع',
  supplierInfo: 'معلومات المورد',
  colProduct: 'المنتج',
  colSku: 'SKU',
  colQty: 'الكمية',
  colUnitPrice: 'سعر الوحدة',
  total: 'المجموع',
  paid: 'المدفوع',
  remaining: 'المتبقي',
  reportGenerated: 'تاريخ الإنشاء',
  reportPhone: 'هاتف',
  reportEmail: 'بريد',
};

/**
 * @param {string} key
 * @param {'fr'|'ar'|boolean} langOrRtl - 'ar'/'fr' or boolean isRTL
 */
export function getInvoicePrintLabel(key, langOrRtl = 'fr') {
  const isAr = langOrRtl === true || langOrRtl === 'ar';
  const map = isAr ? invoicePrintAr : invoicePrintFr;
  return map[key] || key;
}
